<template>
  <div class="feed">
    <HeaderBlock />
    <div class="feed-container">
      <FeedEntry
        v-for="feedItem in feedItems"
        :key="feedItem.id"
        :entry="feedItem"
      />
    </div>
  </div>
</template>

<script>
import FeedEntry from '@/components/FeedEntry.vue';
import HeaderBlock from '@/components/header/HeaderBlock';
import { useIdentityStore } from '@/store/IdentityStore';
import { useFeedStore } from '@/store/FeedStore';
import { mapStores } from 'pinia';

export default {
  name: 'FeedView',
  components: {
    FeedEntry,
    HeaderBlock
  },
  computed: {
    ...mapStores(useFeedStore),
    feedItems () {
      return this.feedStore.filteredFeed;
    },
    user () {
      const identityStore = useIdentityStore();
      return identityStore.User;
    }
  },
  mounted () {
    const identityStore = useIdentityStore();
    if (identityStore.User) { 
      const route = this.$route.params.option;
      this.feedStore.fetchFeed(route); 
    }
  },
  methods: {
    filterFeed (filterType) {
      this.feedStore.filterFeed(filterType);
    }
  },
};
</script>

<style scoped>
.feed {
  display: flex;
  flex-direction: column;
  width: 50%;
  max-width: 750px;
}
/* .view-absolute {
  position: absolute;
} */
.feed-container {
  width: 100%;
  height: 95vh;
  display: flex;
  flex-direction: column;
  transition: width .3s;
  overflow-x: hidden;
  overflow-y: auto;
  /* position: relative; */
  display: flex;
  flex-direction: column;
  flex-flow: column;
}
</style>